
import { isSystemBotTokenConfigured } from '@/services/telegram/botTokenService';

/**
 * Set up default bot commands via edge function
 */
export const setupDefaultCommands = async (): Promise<boolean> => {
  try {
    const isConfigured = await isSystemBotTokenConfigured();
    
    if (!isConfigured) {
      throw new Error('Bot token not configured');
    }

    const response = await fetch('/api/telegram-bot', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        action: 'setup-commands'
      })
    });

    const data = await response.json();
    
    if (data && data.success) {
      return true;
    } else {
      throw new Error(data?.error || 'Failed to set commands');
    }
  } catch (error) {
    console.error('Error setting up commands:', error);
    throw error;
  }
};

/**
 * Get current bot commands via edge function
 */
export const getBotCommands = async (): Promise<any[]> => {
  try {
    const isConfigured = await isSystemBotTokenConfigured();
    
    if (!isConfigured) {
      return [];
    }

    const response = await fetch('/api/telegram-bot', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        action: 'get-commands'
      })
    });
    
    const data = await response.json();
    
    if (data && data.success) {
      return data.commands || [];
    } else {
      return [];
    }
  } catch (error) {
    console.error('Error getting commands:', error);
    return [];
  }
};

/**
 * Test connection - re-export from api for backward compatibility
 */
export { testConnection } from './api';
